module.exports = __webpack_public_path__ + "public/SiteIcons/ListingBackArrow.svg?99c5d7b8";